export default __webpack_public_path__ + "static/media/oval.cbfaceb5.svg";